import { Component, OnInit, OnDestroy, AfterViewInit, ChangeDetectorRef, ViewChild, Output, EventEmitter } from "@angular/core";
import { ACTION_STATUS, ActionBarHandlerModel, ActionbarService } from "src/app/shared/ui/actionbar";
import { NewButtonModel, SaveButtonModel, CancelButtonModel, RefreshButtonModel } from "src/app/shared/ui/actionbar/models";
import { Observable, Subscription } from "rxjs";
import { NavigationService } from "src/app/shared/utils/navigation";
import { SecurityGroupService } from "src/app/core/services/system-services/security-group.service";
import { LoadingSpinnerService } from "src/app/shared/layout/loading-spinner";
import { SecurityGroupSecurityModel } from "src/app/core/models/security-model/security-group-security.model";
import { DxDataGridComponent } from "devextreme-angular";
import * as _ from 'lodash';
import { PaymentAcquirerSortService } from "./payment-acquirer-sort.service";
import { PaymentAcquirerSecurityCode } from "../payment-definition-categories";
import { PaymentAcquirerSort, PaymentAcquirerUpdateSortSequence } from "src/app/core/models/payment-acquirer-model/payment-acquirer-sort.model";

@Component({
    selector: 'op-payment-acquirer-sort',
    templateUrl: './payment-acquirer-sort.component.html'
})
export class PaymentAcquirerSortComponent implements OnInit, OnDestroy, AfterViewInit {

    actionBarHandler = new ActionBarHandlerModel(
        new NewButtonModel(),
        new SaveButtonModel(),
        new CancelButtonModel(),
        new RefreshButtonModel(),
    )

    readonly ExportFileName = "Payment Acquirer"
    readonly PageSize = "A3";
    totalCount: number
    exportHeader: string[]
    exportData: any[]
    selectedRow: PaymentAcquirerSort

    focusing = false
    originDataSourceMap: Map<string, PaymentAcquirerSort>
    dataSource: PaymentAcquirerSort[]
    updateSortSequenceList: PaymentAcquirerUpdateSortSequence[]
    userSecurity: SecurityGroupSecurityModel
    userSecurity$: Observable<SecurityGroupSecurityModel>

    private subscriptions: Subscription[]

    @Output() onUpdateSortSequenceError = new EventEmitter<[string, string]>()
    @ViewChild('dataGrid', { static: false }) dataGrid: DxDataGridComponent;

    constructor(private paymentAcquirerSortService: PaymentAcquirerSortService,
        private navigateService: NavigationService,
        private securityGroupService: SecurityGroupService,
        private loadingSpinnerService: LoadingSpinnerService,
        private actionbarService: ActionbarService,
        private cdr: ChangeDetectorRef,) {
        this.onReorder = this.onReorder.bind(this)
    }
    ngOnInit(): void {
        this.originDataSourceMap = new Map()
        this.subscriptions = []
        this.subscriptions.push(
            this.paymentAcquirerSortService.callSort$.subscribe(() => {

            })
        )

        this.subscriptions.push(
            this.paymentAcquirerSortService.paymentAcquirers$.subscribe(paymentAcquirers => {
                paymentAcquirers.forEach(item =>
                    this.originDataSourceMap.set(item.paymentAcquirerCode, item))

                this.dataSource = _.cloneDeep(paymentAcquirers)
            })
        )

        this.subscriptions.push(
            this.paymentAcquirerSortService.refresh$
                .subscribe(() => {
                    this.refresh()
                })
        )

        this.subscriptions.push(
            this.paymentAcquirerSortService.updateSort$
                .subscribe(() => {
                    this.updateSortSequence()
                })
        )
    }
    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe())
    }
    ngAfterViewInit(): void {
        this.setupActionBar()
        this.refresh()

        this.subscriptions.push(
            this.securityGroupService.userSecurityGroupSecurity
                .subscribe(userSecurities => {
                    this.userSecurity = userSecurities.find(s => s.securityCode == PaymentAcquirerSecurityCode)
                    this.userSecurity$ = new Observable((observer) => observer.next(this.userSecurity))
                    if (this.userSecurity) {
                        this.actionBarHandler.get(ACTION_STATUS.new).enable(this.userSecurity.newFlag)
                        this.actionBarHandler.get(ACTION_STATUS.save).enable(this.userSecurity.editFlag)
                        this.actionbarService.updateState(this.actionBarHandler);
                    }
                })
        )
    }

    refresh() {
        this.loadingSpinnerService.show()
        this.subscriptions.push(
            this.paymentAcquirerSortService.getPaymentAcquirersSort()
                .subscribe(() => {
                    this.loadingSpinnerService.hide()
                    this.cdr.markForCheck()
                },
                    () => this.loadingSpinnerService.hide())
        )
    }

    updateSortSequence() {
        this.prepareSortSequenceListForUpdate()

        if (this.hasDuplicateSortSequence()) {
            this.onUpdateSortSequenceError.emit(['Sort Sequence', 'Sort Sequence is duplicate.'])
            return
        }

        if (!this.updateSortSequenceList.length)
            return

        this.loadingSpinnerService.showSaving()
        this.subscriptions.push(
            this.paymentAcquirerSortService.updateSortSequence(this.updateSortSequenceList).subscribe(() => {
                this.saveCompleteAndContinue(() => {
                    this.refresh()
                })
            }, () => this.loadingSpinnerService.hide())
        )
    }

    private saveCompleteAndContinue(action) {
        this.loadingSpinnerService.saveComplete()
        setTimeout(() => {
            action()
        }, 1000);
    }

    private setupActionBar() {
        this.actionBarHandler.get(ACTION_STATUS.new).enable(false);
        this.actionBarHandler.get(ACTION_STATUS.save).enable(false);
        this.actionBarHandler.get(ACTION_STATUS.cancel).enable(true);
        this.actionBarHandler.get(ACTION_STATUS.refresh).enable(true);
        this.actionbarService.updateState(this.actionBarHandler);
    }

    onContentReady(e): void {
        this.totalCount = e.component.totalCount()

        const filterExpr = this.dataGrid.instance.getCombinedFilter()
        const gridDataSource = this.dataGrid.instance.getDataSource()
        const filterDataSource = gridDataSource?.store().load({
            filter: filterExpr
        })

        const columns = this.dataGrid.instance.getVisibleColumns().filter(x => x.caption)
        const dataFields = Object.values(columns.map(item => item.dataField).filter(f => !!f))
        filterDataSource?.done((response: PaymentAcquirerSort[]) => {
            this.exportData = response.map(r => {
                let model = {}
                dataFields.map((v) => model[v] = r[v])
                return model
            })
        })
        this.exportHeader = columns.map(item => item.caption)
    }
    onRowClick(e): void {
        this.selectedRow = e.data
    }

    onCellPrepared(e): void {
        if (e.rowType === 'data') {
            if (e.column.dataField === 'sortSequence') {
                e.cellElement.addClass('dx-cell-editable')
            }
        }
    }

    onReorder(e): void {
        const visibleRows = e.component.getVisibleRows()
        const toIndex = this.dataSource.findIndex((item) => item.paymentAcquirerCode === visibleRows[e.toIndex].data.paymentAcquirerCode)
        const fromIndex = this.dataSource.findIndex((item) => item.paymentAcquirerCode === e.itemData.paymentAcquirerCode)

        this.dataSource.splice(fromIndex, 1)
        this.dataSource.splice(toIndex, 0, e.itemData)

        this.reOrderSortSequenceForAll()

        this.cdr.markForCheck()
    }

    private prepareSortSequenceListForUpdate(): void {
        this.updateSortSequenceList = this.dataSource.map(item => {
            if (this.originDataSourceMap.get(item.paymentAcquirerCode).sortSequence == item.sortSequence)
                return null

            return <PaymentAcquirerUpdateSortSequence>{
                paymentAcquirerCode: item.paymentAcquirerCode,
                sortSequence: item.sortSequence
            }
        })
            .filter(item => !!item)
    }

    private reOrderSortSequenceForAll(): void {
        let initialSortSequence = 1
        this.dataSource.forEach(dr => {
            dr.sortSequence = initialSortSequence
            initialSortSequence++
        })
    }

    private hasDuplicateSortSequence(): boolean {
        const originValues = this.dataSource.map(dr => dr.sortSequence?.toString())
        const uniqueValues = [...new Set(originValues)]

        return originValues.length != uniqueValues.length
    }

    updateSortSequenceValue(cell, e) {
        const currValue = e.target.value
        const target = this.dataSource.find(item => item.paymentAcquirerCode == cell.data.paymentAcquirerCode)
        if (currValue != null && (+currValue < 1 || +currValue > 99)) {
            target.sortSequence = null
        } else {
            target.sortSequence = currValue
        }
        this.dataGrid.instance.refresh()
    }
}
